/* eslint-disable @typescript-eslint/no-explicit-any */
// import Qs from 'qs'
import { APIReportAgend } from '@/models/api/report-agend.model'
import service from '@/services/service'
// import { FieldName } from '@/interfaces/field-name.interface'

interface GetParams {
    userId: number;
    reportId: number;
}

const resource = {
    main: 'services',
    module: 'report-agends'
}
export class ReportAgendsServices {
    public static getAgendsByUser (params: GetParams) {
        return service.post(`${resource.main}/${resource.module}/by-report`, params)
    }

    public static createReportAgends (params: APIReportAgend) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editReportAgends (params: APIReportAgend) {
        return service.put(`${resource.main}/${resource.module}/${params.agendId}`, params)
    }

    public static deleteReportAgends (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }
}
